/**
 * Which legend entry belongs to which tile and which column.
 *
 * The definitions themselves live on the server and are served by `GET /legend`. This file
 * holds only the mapping, so a definition is written once and every place that shows the
 * number points at the same sentence. An id the response does not carry renders the trigger
 * with no popover: a gap in the legend is a gap in the legend, not a crash on the screen.
 */

/** Tile ids. These are the ids the /legend response is expected to publish. */
export const TILE_LEGEND_ID = {
  critical: 'stock.critical',
  low: 'stock.low',
  out: 'stock.out',
  revenueAtRisk: 'stock.revenue_at_risk',
  inventoryAtCost: 'stock.inventory_at_cost',
  inventoryAtRetail: 'stock.inventory_at_retail',
  invValue: 'stock.inv_value',
  openPoValue: 'stock.open_po_value',
  units30d: 'stock.units_30d',
  revenue30d: 'stock.revenue_30d',
  catalogMargin: 'stock.catalog_margin',
} as const;

/** Column ids, keyed by the DataTable column id so the table can look them up directly. */
export const COLUMN_LEGEND_ID: Readonly<Record<string, string>> = {
  product: 'stock.product',
  on_hand: 'stock.on_hand',
  sales_30d: 'stock.units_30d',
  price: 'stock.sale_price',
  inv_value: 'stock.inv_value',
  cost: 'stock.wac',
  best_price: 'stock.best_price',
  actions: 'stock.actions',
};

/**
 * The index helpers moved to `@/lib/legend` when Orders started using the same legend.
 * They are re-exported here so nothing in this feature had to change its import.
 */
export { indexLegend, definitionFor, detailFor, type LegendIndex } from '@/lib/legend';
